export interface NewsArticle {
  id: string;
  title: string;
  excerpt: string;
  cover: string;
  category: '影评' | '新闻' | '专题' | '预告';
  author: string;
  date: string;
  content: string[];
}

export const news: NewsArticle[] = [
  {
    id: 'n01',
    title: '《星际回响》口碑爆棚：一场关于孤独与回响的太空之旅',
    excerpt:
      '上映三周票房突破 12 亿，《星际回响》用克制的叙事与震撼的视听，重新定义了国产科幻的情感维度。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20space%20scene%20with%20a%20lone%20astronaut%20floating%20before%20a%20giant%20glowing%20amber%20planet%2C%20deep%20space%20backdrop%2C%20dramatic%20warm%20lighting%2C%20high%20detail&width=800&height=500&seq=peach-news-01&orientation=landscape',
    category: '影评',
    author: '影评人 · 顾言之',
    date: '2026-10-08',
    content: [
      '作为今年最受期待的科幻作品之一，《星际回响》并没有把重心放在炫目的特效堆砌上，而是选择用近乎克制的方式，讲述一个宇航员在深空中的孤独旅程。',
      '影片最动人的地方，在于它把宏大的宇宙尺度与微小的个人情感缝合在了一起。当那句“我只是想确认，回响的另一端是否还有人”响起时，放映厅里安静得能听见呼吸。',
      '导演陈逸舟在采访中提到，团队花了两年时间打磨声音设计，希望观众在影院里感受到“被宇宙包裹”的沉浸感。从成片来看，这个目标完成得相当出色。',
      '如果你喜欢更关注人物内心的科幻作品，《星际回响》值得走进影院，感受一次安静的震撼。',
    ],
  },
  {
    id: 'n02',
    title: '2026 秋季档剧集前瞻：年代、都市与奇幻三线齐发',
    excerpt:
      '从《长夜将明》到《长安夜行录》，今年秋季档剧集在题材与制作上全面升级，观众的追剧清单又要变长了。',
    cover:
      'https://readdy.ai/api/search-image?query=Autumn%20city%20skyline%20at%20dusk%20with%20warm%20window%20lights%20and%20dramatic%20clouds%2C%20cinematic%20amber%20tones%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=peach-news-02&orientation=landscape',
    category: '新闻',
    author: '编辑部 · 林知夏',
    date: '2026-10-05',
    content: [
      '随着秋季档正式开启，多部重量级剧集陆续定档，涵盖年代、都市、古装奇幻等热门题材。',
      '其中，《长夜将明》凭借扎实的年代质感与群像叙事，被不少观众视为本季最值得期待的剧集之一；而《长安夜行录》则以精致的东方美学和悬疑主线吸引了大批关注。',
      '都市题材方面，《都市微光》《云端之上》延续近年贴近现实生活的创作方向，聚焦职场与情感议题。',
      '综合来看，本季剧集在制作水准与题材多样性上都有明显提升，观众可以根据自己的偏好各取所需。',
    ],
  },
  {
    id: 'n03',
    title: '专题：为什么我们越来越爱看“小人物”的故事',
    excerpt:
      '从《南方旧事》到《都市微光》，平凡人的日常正在成为影视创作中最动人的部分。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cozy%20neighborhood%20street%20in%20late%20afternoon%20with%20ordinary%20people%20walking%2C%20golden%20amber%20tones%2C%20documentary%20style%2C%20high%20detail&width=800&height=500&seq=peach-news-03&orientation=landscape',
    category: '专题',
    author: '特约撰稿 · 许南',
    date: '2026-10-02',
    content: [
      '近两年的影视市场里，一个明显的趋势是：越来越多作品把镜头对准了普通人。',
      '这些故事的共同点，是不刻意制造戏剧化的冲突，而是在琐碎的日常中捕捉情感的真实瞬间。观众能从中看到自己，也看到身边人。',
      '有评论认为，这种转向与观众审美疲劳有关，也与创作者对真实生活的重新关注有关。无论原因如何，这类作品确实为我们提供了另一种理解生活的方式。',
      '也许，最动人的故事，从来都藏在最普通的日子里。',
    ],
  },
  {
    id: 'n04',
    title: '《暗夜追凶》曝终极预告，十年悬案迎来关键反转',
    excerpt:
      '预告片以压抑的雨夜长镜头开场，短短两分钟内抛出三个令人不寒而栗的疑问。',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20rainy%20night%20city%20street%20with%20neon%20reflections%20and%20a%20shadowy%20silhouette%2C%20tense%20cinematic%20atmosphere%2C%20orange%20and%20teal%20accents%2C%20high%20detail&width=800&height=500&seq=peach-news-04&orientation=landscape',
    category: '预告',
    author: '编辑部 · 郑禾',
    date: '2026-09-28',
    content: [
      '犯罪悬疑片《暗夜追凶》今日发布终极预告。预告以一场雨夜追逐开场，节奏紧凑，信息量十足。',
      '从曝光的片段来看，影片在氛围营造上延续了港式悬疑的一贯水准，霓虹与暗影的对比强化了不安感。',
      '值得一提的是，预告结尾处出现的反转线索，让不少影迷开始重新审视此前发布的所有物料。影片将于月底正式上映。',
    ],
  },
  {
    id: 'n05',
    title: '从镜头到声音：《星际回响》幕后制作特辑上线',
    excerpt:
      '一支长达 18 分钟的幕后特辑，揭开了这部科幻片在声音与视效上的“较真”内幕。',
    cover:
      'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20studio%20with%20crew%20and%20sound%20equipment%2C%20warm%20amber%20lighting%2C%20professional%20cinematography%20feel%2C%20high%20detail&width=800&height=500&seq=peach-news-05&orientation=landscape',
    category: '新闻',
    author: '编辑部 · 林知夏',
    date: '2026-09-24',
    content: [
      '《星际回响》官方近日发布幕后制作特辑，展示了影片在声音设计与视觉特效上的制作细节。',
      '特辑中，声音团队介绍了如何用真实录音叠加合成，营造出“宇宙的寂静与回响”。',
      '视觉方面，团队坚持“看得见的物理感”，大部分太空场景都经过了精细的光照模拟。对制作感兴趣的观众不容错过。',
    ],
  },
  {
    id: 'n06',
    title: '影评：《南方旧事》里的那间老茶馆，藏着一代人的乡愁',
    excerpt:
      '一部没有反派、没有高潮的电影，凭什么让人看完久久难忘？',
    cover:
      'https://readdy.ai/api/search-image?query=Nostalgic%20old%20Chinese%20teahouse%20interior%20with%20warm%20sunlight%20through%20wooden%20windows%2C%20sepia%20amber%20tones%2C%20quiet%20atmosphere%2C%20high%20detail&width=800&height=500&seq=peach-news-06&orientation=landscape',
    category: '影评',
    author: '影评人 · 顾言之',
    date: '2026-09-20',
    content: [
      '《南方旧事》是一部和“快”无关的电影。它的镜头总是慢的，台词也总是留白。',
      '老茶馆这个意象贯穿全片，它既是三代人生活的容器，也是时代变迁的见证者。',
      '影片没有刻意煽情，却在最日常的对话里让人鼻酸。这或许就是它的厉害之处——把克制变成了力量。',
    ],
  },
  {
    id: 'n07',
    title: '专题：动漫迷的秋天，这些新番值得追',
    excerpt:
      '《星轨少年》《剑与江湖》领衔，本季新番在制作与剧本上都带来了不少惊喜。',
    cover:
      'https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20character%20under%20a%20starry%20night%20sky%2C%20warm%20orange%20and%20deep%20indigo%20tones%2C%20energetic%20composition%2C%20high%20detail&width=800&height=500&seq=peach-news-07&orientation=landscape',
    category: '专题',
    author: '特约撰稿 · 顾风',
    date: '2026-09-16',
    content: [
      '秋季新番陆续开播，今年的片单在题材上相当丰富。',
      '《星轨少年》凭借细腻作画与热血剧情，开播即登上热度榜前列；《剑与江湖》则以国风武侠题材吸引了不少关注。',
      '此外，治愈向的《森林小厨神》也凭借温暖的画风收获了一批忠实观众。喜欢的观众可以根据口味自行挑选。',
    ],
  },
  {
    id: 'n08',
    title: '《云端之上》定档：聚焦大厂职场的现实主义新作',
    excerpt:
      '该剧以大厂实习生的视角切入，试图呈现年轻人在理想与现实之间的真实处境。',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20glass%20office%20building%20at%20sunrise%20above%20clouds%2C%20optimistic%20golden%20tones%2C%20clean%20architectural%20photography%2C%20high%20detail&width=800&height=500&seq=peach-news-08&orientation=landscape',
    category: '新闻',
    author: '编辑部 · 郑禾',
    date: '2026-09-12',
    content: [
      '现实主义职场剧《云端之上》正式宣布定档，将于本月下旬开播。',
      '该剧围绕一名来自小城的实习生展开，讲述他在顶级科技公司中的成长与抉择。',
      '主创表示，希望作品能贴近真实的职场生态，而不是贩卖焦虑。剧集能否做到，还有待观众检验。',
    ],
  },
  {
    id: 'n09',
    title: '影评：《夏日放映厅》，献给所有认真爱过的人',
    excerpt:
      '一部关于夏天的电影，却让人在秋天看得泪流满面。',
    cover:
      'https://readdy.ai/api/search-image?query=Outdoor%20cinema%20screen%20glowing%20under%20a%20summer%20evening%20sky%2C%20dreamy%20golden%20bokeh%2C%20warm%20nostalgic%20tones%2C%20high%20detail&width=800&height=500&seq=peach-news-09&orientation=landscape',
    category: '影评',
    author: '影评人 · 温言',
    date: '2026-09-08',
    content: [
      '《夏日放映厅》把爱情讲得很轻，轻得像一阵风，却在你毫无防备时吹进心里。',
      '露天电影这个设定本身就带着怀旧滤镜，配上胶片质感的画面，整部片子散发着温柔的气息。',
      '它没有给爱情一个标准答案，只是安静地告诉你：有些夏天，值得被记一辈子。',
    ],
  },
];